window.Lumera = window.Lumera || {};

Lumera.formatMoney = function (cents) {
  var format = (window.Shopify && window.Shopify.money_format) || '£{{amount}}';
  var amount = (cents / 100).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
  return format.replace(/\{\{\s*amount\s*\}\}/, amount);
};

Lumera.updateCartCount = function () {
  return fetch('/cart.js')
    .then(function (response) { return response.json(); })
    .then(function (cart) {
      document.querySelectorAll('[data-lumera-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });
      return cart;
    })
    .catch(function () {});
};

Lumera.addToCart = function (variantId, quantity) {
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: quantity || 1 }),
  }).then(function (response) {
    if (!response.ok) {
      return response.json().then(function (data) {
        throw new Error(data.description || 'add_failed');
      });
    }
    return response.json().then(function (item) {
      Lumera.updateCartCount();
      return item;
    });
  });
};

document.addEventListener('click', function (event) {
  var button = event.target.closest('[data-lumera-quick-add]');
  if (!button || button.disabled) return;
  event.preventDefault();
  event.stopPropagation();

  var originalText = button.textContent;
  button.disabled = true;
  button.textContent = '...';

  Lumera.addToCart(button.dataset.variantId, 1)
    .then(function () {
      button.textContent = 'Added ✓';
      window.setTimeout(function () {
        button.textContent = originalText;
        button.disabled = false;
      }, 1600);
    })
    .catch(function () {
      button.textContent = 'Try again';
      button.disabled = false;
    });
});
